import { configureStore } from '@reduxjs/toolkit';

import reducer from '../reducer/index';

const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
                ignoredActionsPaths: ['meta.arg', 'payload.timestamp'],
                ignoredPaths: ['items.dates']
            }
        }),
    devTools: process.env.NODE_ENV !== 'production'
});

export default store;
